export const getBackendUrl = (path) => {
  console.log(process.env.REACT_APP_BACKEND);
  return process.env.REACT_APP_BACKEND + path;
};
